module.exports = __webpack_public_path__ + "img/logo_ShareUC_yousee.bdd58afe.jpg";